export class Accounts {
  constructor(http) {
    this.http = http;
  }

  fetchAccounts() {
    return this.http.get('accounts').then(response => response.data);
  }

  fetchAccountsFilter(filter_by, page, sort_by, search, page_size, status) {
    return this.http
      .post('accounts', { filter_by, page, sort_by, search, page_size, status })
      .then(response => response);
  }

  fetchAccount(id) {
    return this.http.get(`account/${id}`).then(response => response.data);
  }

  fetchAccountReports(id) {
    return this.http.get(`account_reports/${id}`).then(response => response.data);
  }

  updateAccount(model) {
    return this.http.put(`account/${model.id}`, { ...model }).then(response => response.data);
  }

  createShiftPeriod(start_time, end_time, account_id) {
    return this.http.post(`shift/periods/${account_id}`, {start_time, end_time}).then(response => response.data);
  }

  updateShiftPeriod(operatorId, period_id) {
    return this.http.patch(`shift/periods/${period_id}`, {operatorId}).then(response => response.data);
  }

  fetchShiftTransfers(account_id) {
    return this.http.get(`shift/transfers/${account_id}`).then(response => response.data);
  }

  deleteShiftPeriod(period_id) {
    return this.http.delete(`shift/periods/${period_id}`).then(response => response.data);
  }

  fetchShiftMap(account_id) {
    return this.http.get(`shift/map/${account_id}`).then(response => response.data);
  }

}
